<div class="row">
  <div class="col-sm-6">
    <app-card [cardOptionBtnValue]="'global.edit'|translate" [cardOptionBtn]="true" [cardRouterLink]="'/back-office/supplier/' + supplier.id" [title]="'admin.supplier.show.supplier_information'|translate">
      <div class="row">
        <div class="col-sm-6 col-xl-6">
          <p class="text-muted m-b-10">{{'doctrine.supplier.number'|translate}}</p>
          <label class="m-b-15">{{supplier.number}}</label>
        </div>
        <div class="col-sm-6 col-xl-6">
          <p class="text-muted m-b-10">{{'doctrine.supplier.companyName'|translate}}</p>
          <label class="m-b-15">{{supplier.companyName}}</label>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 col-xl-6">
          <p class="text-muted m-b-10">{{'doctrine.supplier.address'|translate}}</p>
          <label class="m-b-15">{{supplier.address}}</label>
        </div>
        <div class="col-sm-6 col-xl-6">
          <p class="text-muted m-b-10">{{'doctrine.supplier.zipCode'|translate}}</p>
          <label class="m-b-15">{{supplier.zipCode}}</label>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 col-xl-6">
          <p class="text-muted m-b-10">{{'doctrine.supplier.city'|translate}}</p>
          <label class="m-b-15">{{supplier.city}}</label>
        </div>
        <div class="col-sm-6 col-xl-6">
          <p class="text-muted m-b-10">{{'doctrine.supplier.country'|translate}}</p>
          <label class="m-b-15">{{supplier.countryName}}</label>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 col-xl-6">
          <p class="text-muted m-b-10">{{'doctrine.supplier.email'|translate}}</p>
          <label class="m-b-15">{{supplier.email}}</label>
        </div>
        <div class="col-sm-6 col-xl-6">
          <p class="text-muted m-b-10">{{'doctrine.supplier.phone'|translate}}</p>
          <label class="m-b-15">{{supplier.phone}}</label>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-xl-6">
          <p class="text-muted m-b-10">{{'doctrine.supplier.status'|translate}}</p>
          <label class="m-b-15">{{(supplier.status ? 'global.active' : 'global.inactive')|translate}}</label>
        </div>
      </div>
    </app-card>
  </div>
  <div class="col-sm-6">
    <app-card [cardOptionBtnValue]="'global.edit'|translate" [cardOptionBtn]="false" [title]="'admin.supplier.show.linked_models'|translate">
      <div class="row">
        <div class="col-sm-6">
          <ngx-treeview
            [config]="config"
            [items]="items"
            [itemTemplate]="itemTemplate"
            (selectedChange)="onSelectedChange($event)"
            (filterChange)="onFilterChange($event)">
          </ngx-treeview>
        </div>
      </div>
      <div class="card-block-hid ng-trigger ng-trigger-cardToggle" style="overflow: hidden;">
        <div class="card-block pull-right">
          <button (click)="submitItem(false)" class="btn btn-link" type="button">{{'global.cancel'|translate}}</button>
          <button (click)="submitItem(true)" class="btn btn-primary ripple light" type="button">{{'global.save_changes'|translate}}</button>
        </div>
      </div>
    </app-card>
  </div>
</div>
<ng-template #itemTemplate let-item="item" let-onCollapseExpand="onCollapseExpand" let-onCheckedChange="onCheckedChange">
  <div class="form-inline row-item">
    <i *ngIf="item.children" (click)="onCollapseExpand()" aria-hidden="true" class="fa" [class.fa-caret-right]="item.collapsed"
       [class.fa-caret-down]="!item.collapsed"></i>
    <div class="form-check">
      <input type="checkbox" disabled="disabled" class="form-check-input" [(ngModel)]="item.checked" (ngModelChange)="onCheckedChange()" [indeterminate]="item.indeterminate" />
      <label class="form-check-label">
        {{item.text}}
      </label>
    </div>
  </div>
</ng-template>
